import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';

import { getTranslate } from 'react-localize-redux';
import { InfoMessage, TopActionBar } from '../../common/components';
import urls from '../../app/urls';
import { ForwardIcon } from '../../common/icons';
import { HtmlContent, Image } from '../../youwell-common/components';
import apiUrls from '../../youwell-common/apiUrls';

export const styles = theme => ({
    root: {
    },
    content: {
        minHeight: '80vh',
        padding: theme.spacing(2, 4),

        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4),
        },
    },
    imageContainer: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
    },
    image: {
        float: 'right',
        marginLeft: theme.spacing(2),
        maxWidth: '100%',
        maxHeight: '200px',
    },
    description: {
        flex: '1 1 auto',
    },
    divideBorder: {
        borderBottom: theme.borders.normal,
        margin: theme.spacing(3, 0, 1),
    },
    links: {
        padding: theme.spacing(2),
    },
    link: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            justifyContent: 'space-between',
        },
    },
    icon: {
        marginLeft: theme.spacing(3),
    },
});

const Module = ({
    classes, translate, module, hasLoaded,
}) => {
    if (!module) {
        return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
    }

    const moduleImage = module.moduleImageId ? `${apiUrls.baseUrl}/${apiUrls.media.file}/${module.moduleImageId}` : null;

    return (
        <div className={classes.root}>
            <TopActionBar
                title={module.name}
                backLink={{
                    to: `${urls.inside.home}`,
                    text: translate('program.backToOverview'),
                }}
            />

            <div className={classes.content}>
                {moduleImage && (
                    <div className={classes.imageContainer}>
                        <Image src={moduleImage} className={classes.image} alt={translate('module.moduleImageAltText')} />
                    </div>
                )}

                <HtmlContent html={module.description} className={classes.description} />
                {module.description && module.tasks && <div className={classes.divideBorder} />}

                <div className={classes.links}>
                    {module.tasks?.map(task => (
                        <Link key={task.id} to={`${urls.inside.resource.task}/${task.id}`}>
                            <Typography variant="body2" className={classes.link}>
                                {task.name}
                                <ForwardIcon className={classes.icon} />
                            </Typography>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

Module.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    module: PropTypes.object,
};

Module.defaultProps = {
    module: null,
};

const mapStateToProps = (state, ownProps) => {
    const itemId = ownProps?.match?.params?.moduleId;
    const module = itemId && state.program.content && state.program.content[state.pageSettings.appConfig?.resourcesProgramId]?.modules
        ?.find(d => d.id === itemId);

    return {
        translate: getTranslate(state.localize),
        clientConfig: state.auth.clientConfig,
        hasLoaded: Boolean(state.program.content && state.program.content[state.pageSettings.appConfig?.resourcesProgramId]),
        module,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(Module));
